import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import _ from 'lodash';
import { groupSchema, groupListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/groups/actions';
import { getCompetition } from 'app/ducks/competitions/actions';

import { GroupsActionTypes as types } from 'app/ducks/groups/types';

function* createGroupSaga(action): any {
  yield put(sagaActions.createGroupPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).groups.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, groupSchema);

    yield put(sagaActions.createGroupSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createGroupFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updateGroupSaga(action): any {
  yield put(sagaActions.updateGroupPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).groups.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, groupSchema);

    yield put(sagaActions.updateGroupSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateGroupFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getGroupSaga(action): any {
  yield put(sagaActions.getGroupPending());
  const [error, response] = yield (yield TeammoApi(yield select())).groups.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, groupSchema);
    yield put(sagaActions.getGroupSuccess(normalizedResponse));
    const group = normalizedResponse.entities.groups[normalizedResponse.result];
    if (!_.isEmpty(group.competition)) {
      yield put(yield getCompetition(group.competition.id));
    }
    return group;
  }
  yield put(
    handleError(error, sagaActions.getGroupFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

function* getAllGroupsSaga(action): any {
  let [error, response] = [undefined, undefined];
  yield put(
    sagaActions.getAllGroupsPending(action.payload.compile ? action.payload.pagination : {}),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(yield select((state) => state.groups.pagination))
    : action.payload.pagination;

  if (action.payload.organisationId === undefined) {
    [error, response] = yield (
      yield TeammoApi(yield select(), action.payload.organisationIds)
    ).groups.list(paginationObject);
  } else {
    [error, response] = yield (
      yield TeammoApi(yield select(), action.payload.organisationIds)
    ).groups.organisationList(action.payload.organisationId, paginationObject);
  }

  if (response) {
    const normalizedResponse = normalize(response, groupListSchema);

    yield put(
      sagaActions.getAllGroupsSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
    return normalizedResponse;
  }
  yield put(
    handleError(error, sagaActions.getAllGroupsFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createGroupSagaWatcher(): any {
  yield takeLatest(types.CREATE_GROUP_REQUESTED, createGroupSaga);
}

function* updateGroupSagaWatcher(): any {
  yield takeLatest(types.UPDATE_GROUP_REQUESTED, updateGroupSaga);
}

function* getGroupSagaWatcher(): any {
  yield takeEvery(types.GET_GROUP_REQUESTED, getGroupSaga);
}

function* getAllGroupsSagaWatcher(): any {
  yield takeEvery(types.GET_ALL_GROUPS_REQUESTED, getAllGroupsSaga);
}

export default function* root(): any {
  yield all([
    createGroupSagaWatcher(),
    updateGroupSagaWatcher(),
    getGroupSagaWatcher(),
    getAllGroupsSagaWatcher(),
  ]);
}
